document.querySelectorAll('.FileUploader').forEach((el) => {
    const listEl = el.querySelector('.FileUploader__list');
    const inputEl = el.querySelector('input');
    const resetBtn = el.querySelector('.FileUploader__reset');

    inputEl.addEventListener('input', (e) => {
        const files = e.target.files;
        Array.from(files).forEach((file) => {
            if (file.size <= (1024 * 1000 * 10)) {
                listEl.append(getElFile(file));
            }
        });

        setActive(listEl.childElementCount);
        addEventListeners();
        e.target.value = '';
    });

    resetBtn.addEventListener('click', () => {
        listEl.innerHTML = '';
        setActive(false);
    });

    function getElFile(file) {
        const url = URL.createObjectURL(file);
        const div = document.createElement('div');
        div.className = 'FileUploader__file';
        div.style.backgroundImage = `url(${url})`;
        const input = document.createElement('input');
        for (let attr of inputEl.attributes) {
            input.setAttribute(attr.name, attr.value);
        }
        const fl = new DataTransfer();
        fl.items.add(file);
        input.files = fl.files;
        div.append(input);
        return div;
    }

    function addEventListeners() {
        listEl.querySelectorAll('.FileUploader__file').forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                el.remove();
                setActive(listEl.childElementCount);
            })
        });
    }

    function setActive(state) {
        el.classList.toggle('FileUploader--active', state);
    }
})
